import { AccountConstants } from "finhelper";

import FilterAccount from "#app/domain/clients/FilterAccount";

import { buildFetchItemsQuery } from "../clients/legacy";
import type { LaravelQueryBuilder } from "../types/laravelRequest";

/**
 * Клиенты для графика воронки: те же фильтры что список клиентов, плюс брокерские user_accounts.
 */
export const buildFunnelChartClientsQuery = (isFullGroup: boolean) => {
    const query = buildFetchItemsQuery(null, false, null, isFullGroup);
    query.with(
        "user_accounts",
        (nested: LaravelQueryBuilder) =>
            nested
                .with("accounts")
                .with("accounts.currency")
                .with("accounts.currency.cb_currency")
                .where("type_id", AccountConstants.BROKER_ACCOUNT)
                .whereIn("bank_id", FilterAccount.ACCOUNT_BANKS)
    );
    return query;
};
